/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum ISOs {
  ATA = 'ATA',
  CAN = 'CAN',
  CHE = 'CHE',
  DEU = 'DEU',
  GBR = 'GBR',
  KOR = 'KOR',
  NLD = 'NLD',
  NZL = 'NZL',
  USA = 'USA',
  ZAF = 'ZAF',
  AQ = 'ATA',
  CA = 'CAN',
  CH = 'CHE',
  DE = 'DEU',
  GB = 'GBR',
  KR = 'KOR',
  NL = 'NLD',
  NZ = 'NZL',
  US = 'USA',
  ZA = 'ZAF',
}

export enum RegionToISOs {
  AQ = ISOs.ATA,
  CA = ISOs.CAN,
  CH = ISOs.CHE,
  DE = ISOs.DEU,
  GB = ISOs.GBR,
  KR = ISOs.KOR,
  NL = ISOs.NLD,
  NZ = ISOs.NZL,
  US = ISOs.USA,
  ZA = ISOs.ZAF,
}

export enum ISOsToRegions {
  ATA = 'AQ',
  CAN = 'CA',
  CHE = 'CH',
  DEU = 'DE',
  GBR = 'GB',
  KOR = 'KR',
  NLD = 'NL',
  NZL = 'NZ',
  USA = 'US',
  ZAF = 'ZA',
}

export enum PaymentISOs {
  AQ = 'AQ',
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  GB = 'GB',
  KR = 'KR',
  NL = 'NL',
  NZ = 'NZ',
  US = 'US',
  ZA = 'ZA',
}

export enum Currencies {
  CAD = 'CAD',
  CHF = 'CHF',
  EUR = 'EUR',
  GBP = 'GBP',
  KRW = 'KRW',
  NZD = 'NZD',
  USD = 'USD',
  ZAR = 'ZAR',
}

export const BILLING_COUNTRIES = {
  [ISOs.ATA]: { countryCode: PaymentISOs.AQ, currencyCode: Currencies.USD },
  [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD },
  [ISOs.CHE]: { countryCode: PaymentISOs.CH, currencyCode: Currencies.CHF },
  [ISOs.DEU]: { countryCode: PaymentISOs.DE, currencyCode: Currencies.EUR },
  [ISOs.GBR]: { countryCode: PaymentISOs.GB, currencyCode: Currencies.GBP },
  [ISOs.KOR]: { countryCode: PaymentISOs.KR, currencyCode: Currencies.KRW },
  [ISOs.NLD]: { countryCode: PaymentISOs.NL, currencyCode: Currencies.EUR },
  [ISOs.NZL]: { countryCode: PaymentISOs.NZ, currencyCode: Currencies.NZD },
  [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD },
  [ISOs.ZAF]: { countryCode: PaymentISOs.ZA, currencyCode: Currencies.ZAR },
};
